import { createContext, useContext } from 'react';

const CustomerSuccessHistoryContext = createContext();

CustomerSuccessHistoryContext.displayName = 'CustomerSuccessHistoryContext';

const useCustomerSuccessHistory = () => useContext(CustomerSuccessHistoryContext);

export { CustomerSuccessHistoryContext, useCustomerSuccessHistory };
